// Prefix for the stable class names react-select adds to its own parts in the shared Select
// (pm-select__menu, pm-select__dropdown-indicator, ...), so app styles and restaurant custom CSS have
// something to target.
export const SELECT_CLASS_NAME_PREFIX = 'pm-select';
